import { ng1ViewsBuilder } from "@uirouter/angularjs";
import { AdeMesError, HourWork } from "../commonClasses";

declare var angular: any;

module Header {

    export interface HeaderDirectiveScope extends ng.IScope {
        $location: ng.ILocationService;
        headerDetail: boolean;
        documentButton: boolean;
        hasPrevState: () => boolean;
        doLogout: (event: MouseEvent) => void;
        goPrevState: (event: MouseEvent) => void;
        showReportListLink: () => boolean;
        showCustomersLink: () => boolean;
        goToReportList: (event: MouseEvent) => void;
        goToCustomers: (event: MouseEvent) => void;
        goToUrl: () => void;
        manageNc: () => boolean;
        interval: number;
    }

    interface BugDataContainer {
        bugType: string;
        bugDescription: string;
    };

    export class HeaderDirective implements ng.IDirective {

        static $inject = ["$location", "$state", "MainService", "RolesService", "HeaderService", "toaster", "$translate"];

        constructor(
            private $location: ng.ILocationService,
            private $state: angular.ui.IStateService,
            protected MainService: any,
            protected RolesService: any,
            protected HeaderService: any,
            protected toaster: toaster.IToasterService,
            protected $translate: angular.translate.ITranslateService
        ) {

        };

        restrict = "E";
        templateUrl = "app/shared/header/header.html";
        replace = true;

        controller = ["$scope", "$state", "RolesService", "toaster", "$mdDialog", "blockUI", "ConfigService", "$translate", "$window", "$location", "GlobalApplicationData","$rootScope",
            ($scope: any, $state: angular.ui.IStateService, RolesService: any, toaster: toaster.IToasterService,
                $mdDialog: angular.material.IDialogService, blockUI: angular.blockUI.BlockUIService, ConfigService: any,
                $translate: angular.translate.ITranslateService, $window: angular.IWindowService, $location: any, GlobalApplicationData: any, $rootScope: HeaderDirectiveScope) => {
                let _self = this;

                $scope.headerDetail = GlobalApplicationData.headerDetail;
                console.log("1", $scope.headerDetail);
                $scope.documentButton = GlobalApplicationData.documentButton;
                $scope.showAlerts = GlobalApplicationData.showAlerts;

                _self.HeaderService.userWorkReport.query({
                }).$promise.then((data: HourWork) => {
                    $scope.work = data.hourwork;
                    $scope.report = data.hourlastreport;
                    $scope.url = data.url;
                    console.log($scope.url);
                }).catch((error: AdeMesError) => {

                });

                $scope.hasPrevState = (): boolean => {
                    return $state.current.name !== localStorage.getItem("default_state");
                };

                let eventListener = $scope.$on('$locationChangeStart', function (e: any) {
                    let path: string = $location.path();
                    console.log("path", path);
                    if ($scope.actualLocation === "/customer" && $location.path() === "/login" || $scope.actualLocation === "/login" && $location.path() === "/login") {
                        $scope.doLogout(e);
                    }
                });

                $scope.doLogout = (event: MouseEvent): void => {
                    event.preventDefault();

                    let finalizeLogout = () => {
                        _self.MainService.cleanJWT();

                        blockUI.stop();

                        _self.$state.go("login");
                    };

                    var confirm: angular.material.IConfirmDialog = $mdDialog.confirm()
                        .title($translate.instant("generic.logout.confirm.title"))
                        .textContent($translate.instant("generic.logout.confirm.body"))
                        .targetEvent(event)
                        .ok($translate.instant("generic.logout.confirm.ok-button"))
                        .cancel($translate.instant("generic.logout.confirm.cancel-button"))
                        .openFrom("#btn-logout-header")
                        .closeTo("#btn-logout-header");

                    $mdDialog.show(confirm).then(() => {
                        blockUI.start();

                        _self.HeaderService.logout.query({
                        }).$promise.then(() => {
                            console.log("logout ok");

                            finalizeLogout();
                        }).catch((error: AdeMesError) => {
                            console.error("error on do logout:", error);

                            finalizeLogout();
                        });
                    }).catch(() => {
                        //NOTHING TO DO
                    });
                };

                $scope.goPrevState = (event: MouseEvent): void => {
                    event.preventDefault();

                    $window.history.back();
                };

                $scope.showReportListLink = (): boolean => {
                    return _self.RolesService.loggedUserHasRole("ROLE_BASE")
                        && $state.current.name === localStorage.getItem("default_state") && GlobalApplicationData.showReportListButton;
                };

                $scope.showCustomersLink = (): boolean => {
                    return _self.RolesService.loggedUserHasRole("ROLE_BASE")
                        && $state.current.name !== localStorage.getItem("default_state");
                };

                $scope.goToUrl = (): void => {
                    $window.open($scope.url, '_blank');
                };

                $scope.goToReportList = (event: MouseEvent): void => {
                    event.preventDefault();

                    $state.go("report-list");
                };

                $scope.goToCustomers = (event: MouseEvent): void => {
                    event.preventDefault();
                    $state.go(localStorage.getItem("default_state"));
                };

                $scope.manageNc = (): boolean => {
                    return GlobalApplicationData.jwtPayload.manage_nc;
                }


                
                $scope.checkAlerts = (): void => {
                    let _self = this;
                    
                    _self.HeaderService.getPhaseTypeAlert.query({}).$promise.then((alerts: Array<any>) => {

                        if(alerts && alerts.length > 0){
                            $scope.openAlerts();
                        }
                        
                    }).catch((error: AdeMesError) => {
                        if (error.message == null) {
                            error.message = "Errore negli alerts";
                        }
                    });
                }
                
                let dialogOpened = false;

                //Controllo ogni 5 minuti se ci sono degli alert
                var MINUTE = 1000 * 60;
                
                if($scope.showAlerts && !$rootScope.interval){
                    $rootScope.interval = setInterval(function(){
                        if(!dialogOpened){
                            $scope.checkAlerts();
                        }
                    }, MINUTE * 5);
                }

                //$scope.checkAlerts();

                $scope.openAlerts = (): void => {
                    /* if(event){
                        event.preventDefault();
                    } */
                    let _self = this;
                    let intervalDialog:number;
                    _self.HeaderService.getPhaseTypeAlert.query({}).$promise.then((alerts: Array<any>) => {  
                        $mdDialog.show({
                            controller: ($scope: any, $mdDialog: ng.material.IDialogService) => {
                                dialogOpened = true;
                                $scope.alerts = alerts;
                                $scope.loggedUser = GlobalApplicationData.jwtPayload.username;
                                $scope.cancel = () => {
                                    let body = angular.element(document.querySelector("body"));
                                    body.removeClass("no-scroll");
                                    // dialogOpened = false;
                                    // intervalDialog = undefined;
                                    $mdDialog.cancel();
                                };

                                $scope.goTo = (event: MouseEvent, page: string, id: any): void => {
                                    event.preventDefault();
                                    if(page && id){
                                        this.$state.go(page, {
                                            projectPhaseId: id
                                        });
                                    }
                                    
                                    // intervalDialog = undefined;
                                    // dialogOpened = false;
                                    $mdDialog.cancel();
                                }

                                intervalDialog = setInterval(function(){
                                    if(dialogOpened){
                                        _self.HeaderService.getPhaseTypeAlert.query({}).$promise.then((alerts: Array<any>) => {

                                            $scope.alerts = alerts;
                                            
                                        }).catch((error: AdeMesError) => {
                                            if (error.message == null) {
                                                error.message = "Errore negli alerts";
                                            }
                                        });
                                    }
                                }, MINUTE * 5);

                                
                            },
                            templateUrl: "app/shared/header/dialog/alerts.html",
                            clickOutsideToClose: true,
                            fullscreen: false,
                            multiple: false,
                            onRemoving: function (event, removePromise) {
                                dialogOpened = false;
                                clearInterval(intervalDialog);
                            }
                        }).then(() => {
                            //NOTHING TO DO
                        }).catch((error: AdeMesError) => {
                            if (error) {
                                if (error.message == null) {
                                    error.message = "Errore nel dialog degli alerts";
                                }
                            }
                        });
                        //$scope.cancel();

                    }).catch((error: AdeMesError) => {
                        if (error.message == null) {
                            error.message = "Errore negli alerts";
                        }
                    });
                }

            }
        ];
    }

    // registro la direttiva
    angular.module("AdeMesApp").directive("tzHeader", ($location: ng.ILocationService, $state: angular.ui.IStateService, MainService: any, RolesService: any, HeaderService: any, toaster: toaster.IToasterService, $translate: angular.translate.ITranslateService) => new Header.HeaderDirective($location, $state, MainService, RolesService, HeaderService, toaster, $translate));
}
